import {forwardRef, Ref} from 'react';
import PageImage from './PageImage';
import {CONTENT_CARD_THUMB_FIT_CN} from '../constant';

interface IProps {
  src: string;
  className?: string;
  pictureClassName?: string;
  isLazy?: boolean;
}

function ContentThumbnailV4(
  {src, className, pictureClassName, isLazy}: IProps,
  ref: Ref<HTMLPictureElement>
) {
  return (
    <PageImage
      ref={ref}
      src={src}
      alt=""
      className={cn('w-full h-full', CONTENT_CARD_THUMB_FIT_CN, className)}
      pictureClassName={pictureClassName}
      isLazy={isLazy}
    />
  );
}

export default forwardRef(ContentThumbnailV4);
